{
  "loading": "טוען...",
  "loadingMore": "טוען עוד..."
}